module.exports = __webpack_public_path__ + "img/icon-caution.628a6b3f.svg";